// removed by extract-text-webpack-plugin
module.exports = {"modalHidden":"Modal__modalHidden___3bsxg","modalBackdrop":"Modal__modalBackdrop___3utdi","modal":"Modal__modal___-IsRB","dismiss":"Modal__dismiss___3T7C-"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Modal.css
// module id = 1564
// module chunks = 0